module.exports = __webpack_public_path__ + "static/media/keymap_bash_ctrl.78951615.png";